<template>
	<a-modal
		class="g-image-card-edit-modal"
		:visible="visible"
		title="图片模块编辑"
		width="730px"
		:centered="true"
		:mask-closable="false"
		:destroy-on-close="true"
		@cancel="onCancel"
	>
		<div class="g-edit-modal__scroll">
		<div class="g-image-card-edit" @click="clearSelection">
			<div class="g-image-card-edit__actions" @click.stop>
				<!-- <span v-if="hasSortableThumbs" class="g-image-card-edit__hint">缩略图支持拖拽排序</span> -->
				<div class="g-image-card-edit__actions-btns">
					<button type="button" class="g-image-card-edit__batch-btn" @click="addCard">添加一张</button>
				</div>
			</div>

			<div
				ref="editGrid"
				class="g-image-card-edit__grid"
			>
				<div
					v-for="(item, index) in form.items"
					:key="item.id"
					class="g-image-card-edit__cell-wrap"
					:class="{ 'is-active': selectedIndex === index }"
					@click.stop
				>
					<button
						v-if="form.items.length > 1"
						type="button"
						class="g-image-card-edit__card-delete"
						title="删除卡片"
						@click.stop="deleteItem(index)"
					>
						<i class="mbm-iconfont mbm-guanbi1" aria-hidden="true"></i>
					</button>
					<div
						class="g-image-card-edit__cell"
						:class="{ 'is-selected': selectedIndex === index }"
						@click="selectItem(index)"
					>
						<div
							class="g-image-card-edit__cover"
							:style="previewCoverStyle"
						>
							<UploadProgressPanel
								v-if="isUploading && selectedIndex === index"
								:tasks="uploadTasks"
								variant="item"
								hide-filename
							/>
							<template v-else>
								<img v-if="getPreviewCoverUrl(item)" :src="getPreviewCoverUrl(item)" alt="" />
								<i v-else class="mbm-iconfont mbm-tupian"></i>
								<span
									v-if="item.showImageCount && item.items.length"
									class="g-image-card-edit__badge"
								>{{ item.items.length }}图</span>
							</template>
						</div>
						<input
							v-model="item.subtitle"
							type="text"
							class="g-image-card-edit__subtitle-input"
							:style="{ color: item.subtitleColor }"
							maxlength="40"
							placeholder="副标题"
							@click.stop="selectItem(index)"
							@focus="selectItem(index)"
						/>
						<input
							v-model="item.title"
							type="text"
							class="g-image-card-edit__title-input"
							:style="{ color: item.titleColor }"
							maxlength="40"
							placeholder="标题"
							@click.stop="selectItem(index)"
							@focus="selectItem(index)"
						/>
						<EditListSortGroup
							v-if="item.items.length"
							class="g-image-card-edit__thumbs"
							@dragover="onThumbSortDragOver"
							@drop.prevent="onThumbDragEnd"
						>
							<div
								v-for="(image, thumbIndex) in item.items"
								:key="image.id"
								:data-sort-id="image.id"
								class="g-image-card-edit__thumb"
								:class="[
									{ 'is-active': getPreviewImageIndex(item) === thumbIndex },
									getEditListSortItemClass(thumbDragState.dragId, image.id, thumbDragState.dragOverId),
								]"
								style="border-radius: 3px;"
								:draggable="item.items.length > 1"
								@dragstart.stop="onThumbDragStart(item, image.id, index, $event)"
								@dragend.stop="onThumbDragEnd"
								@click.stop="selectPreviewImage(item, thumbIndex, index)"
							>
								<img v-if="getImageUrl(image)" :src="getImageUrl(image)" alt="" draggable="false" />
							</div>
							<div
								class="g-image-card-edit__thumb g-image-card-edit__thumb--add"
								:style="{ borderRadius: `${form.borderRadius}px` }"
								@click.stop="selectItem(index); triggerAddImage()"
							>
								<span>+</span>
							</div>
						</EditListSortGroup>
					</div>

					<div
						v-if="selectedIndex === index"
						class="g-image-card-edit__panel g-image-card-edit__panel--arrow g-image-card-edit__panel--float"
						:class="getPanelAlignClass(index)"
						@click.stop
					>
						<div class="g-image-card-edit__toolbar">
							<button type="button" class="g-image-card-edit__action" @click="triggerReplaceCover">换图</button>
							<button type="button" class="g-image-card-edit__action" @click="triggerAddImage">加图</button>
							<button
								type="button"
								class="g-image-card-edit__action"
								:class="{ 'is-active': !selectedItem?.showImageCount }"
								@click="toggleImageCount"
							>隐藏张数</button>
							<button
								type="button"
								class="g-image-card-edit__action"
								:class="{ 'is-active': activePanel === 'height' }"
								@click="togglePanel('height')"
							>高度</button>
							<button
								type="button"
								class="g-image-card-edit__action"
								:class="{ 'is-active': activePanel === 'radius' }"
								@click="togglePanel('radius')"
							>圆角</button>
							<button
								type="button"
								class="g-image-card-edit__action g-image-card-edit__action--danger-text"
								:disabled="!selectedItem || selectedItem.items.length <= 1"
								@click="deleteSelectedImage"
							>删除</button>
							<div class="g-image-card-edit__colors">
								<ColorPicker
									:model-value="selectedItem?.subtitleColor"
									@update:model-value="onSubtitleColorInput($event)"
								/>
								<ColorPicker
									:model-value="selectedItem?.titleColor"
									@update:model-value="onTitleColorInput($event)"
								/>
							</div>
						</div>
						<div v-if="activePanel === 'height'" class="g-image-card-edit__sub-row">
							<span class="g-image-card-edit__sub-label">高度 (px)</span>
							<a-input-number
								v-model:value="heightDraft"
								:min="1"
								:max="800"
								:precision="0"
								class="g-image-card-edit__sub-input"
							/>
							<button type="button" class="g-image-card-edit__sub-confirm" @click="applyHeight">确定</button>
							<span class="g-image-card-edit__sub-default">默认值:{{ defaultHeight }}</span>
						</div>
						<div v-if="activePanel === 'radius'" class="g-image-card-edit__sub-row">
							<span class="g-image-card-edit__sub-label">圆角 (px)</span>
							<a-input-number
								v-model:value="radiusDraft"
								:min="0"
								:max="100"
								:precision="0"
								class="g-image-card-edit__sub-input"
							/>
							<button type="button" class="g-image-card-edit__sub-confirm" @click="applyRadius">确定</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		</div>

		<input
			ref="imageInput"
			type="file"
			accept="image/*"
			class="g-image-card-edit__file-input"
			@change="onImageSelect"
		/>

		<template #footer>
			<a-button @click="onCancel">取消</a-button>
			<a-button type="primary" class="g-image-card-edit-modal__ok" :disabled="isUploading" @click="onConfirm">确定</a-button>
		</template>
	</a-modal>
</template>

<script>
	import {
		isLocalImageFile,
		MAX_LOCAL_IMAGE_SIZE,
		revokeLocalImageUrl,
	} from '../utils/localImage.js';
	import {
		createDefaultImageCardItem,
		getImageCardCoverImage,
		getImageCardCoverAspectRatio,
		getImageCardImageUrl,
		IMAGE_CARD_DEFAULT_HEIGHT,
		normalizeImageCardData,
		replaceImageCardGalleryImage,
	} from '../utils/imageCard.js';
	import { getSwatchBorderColor, normalizeHexColor } from '../utils/richText.js';
	import { ensureEditFloatPanelVisible, getGridPanelAlignClass } from '../utils/editPanelAlign.js';
	import EditListSortGroup from './EditListSortGroup.vue';
	import {
		clearEditListSortDragState,
		createEditListDragState,
		getEditListSortItemClass,
		handleEditListSortDragEnd,
		handleEditListSortDragOver,
		handleEditListSortDragStart,
	} from '../utils/editListDragSort.js';
	import UploadProgressPanel from './UploadProgressPanel.vue';
	import ColorPicker from './ColorPicker.vue';
	import {
		createUploadTasks,
		updateUploadTaskProgress,
		uploadHeaderMediaFiles,
	} from '../utils/uploadHeaderMedia.js';

	export default {
		name: 'GImageCardEditModal',
		components: { EditListSortGroup, UploadProgressPanel, ColorPicker },
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		emits: ['update:visible', 'confirm'],
		data() {
			return {
				form: normalizeImageCardData({}),
				selectedIndex: null,
				activePanel: '',
				heightDraft: IMAGE_CARD_DEFAULT_HEIGHT,
				radiusDraft: 8,
				defaultHeight: IMAGE_CARD_DEFAULT_HEIGHT,
				imageSelectMode: 'replace',
				previewImageIndexes: {},
				thumbDragState: createEditListDragState(),
				thumbDragItemId: '',
				thumbSortContainer: null,
				isUploading: false,
				uploadTasks: [],
			};
		},
		computed: {
			selectedItem() {
				return this.form.items[this.selectedIndex] || null;
			},
			hasSortableThumbs() {
				return (this.form.items || []).some(item => (item.items?.length || 0) > 1);
			},
			previewCoverStyle() {
				return {
					aspectRatio: getImageCardCoverAspectRatio(this.form.imageHeight),
					borderRadius: `${this.form.borderRadius}px`,
				};
			},
		},
		watch: {
			visible(val) {
				if (val) {
					this.selectedIndex = null;
					this.activePanel = '';
					this.previewImageIndexes = {};
					this.resetThumbDrag();
					this.syncForm();
				}
			},
			data: {
				deep: true,
				handler() {
					if (this.visible) {
						this.syncForm();
					}
				},
			},
		},
		methods: {
			getEditListSortItemClass,
			getPanelAlignClass(index) {
				return getGridPanelAlignClass(index, 2);
			},
			ensureActivePanelVisible() {
				ensureEditFloatPanelVisible(this, {
					wrapSelector: '.g-image-card-edit__cell-wrap',
					panelSelector: '.g-image-card-edit__panel--float',
				});
			},
			normalizeColor(color) {
				return normalizeHexColor(color);
			},
			getImageUrl(image) {
				return getImageCardImageUrl(image);
			},
			getPreviewImageIndex(item) {
				const idx = this.previewImageIndexes[item.id];
				const len = item.items?.length || 0;
				if (Number.isFinite(idx) && idx >= 0 && idx < len) {
					return idx;
				}
				return 0;
			},
			setPreviewImageIndex(item, thumbIndex) {
				this.previewImageIndexes = {
					...this.previewImageIndexes,
					[item.id]: thumbIndex,
				};
			},
			selectPreviewImage(item, thumbIndex, cardIndex) {
				this.selectItem(cardIndex);
				this.setPreviewImageIndex(item, thumbIndex);
			},
			onThumbDragStart(item, imageId, cardIndex, event) {
				if ((item.items?.length || 0) <= 1) {
					event.preventDefault();
					return;
				}
				this.selectItem(cardIndex);
				this.thumbDragItemId = item.id;
				this.thumbSortContainer = event.currentTarget.closest('.g-edit-list-sort-group');
				handleEditListSortDragStart(this.thumbDragState, imageId);
				event.dataTransfer.effectAllowed = 'move';
				event.dataTransfer.setData('text/plain', imageId);
			},
			onThumbSortDragOver(event) {
				if (!this.thumbDragState.dragId) return;
				const containerRef = this.thumbSortContainer || event.currentTarget;
				handleEditListSortDragOver(event, containerRef, this.thumbDragState);
			},
			onThumbDragEnd() {
				if (!this.thumbDragState.dragId) {
					this.resetThumbDrag();
					return;
				}
				const cardItem = this.form.items.find(entry => entry.id === this.thumbDragItemId);
				if (!cardItem) {
					this.resetThumbDrag();
					return;
				}
				const previewImageId = cardItem.items[this.getPreviewImageIndex(cardItem)]?.id;
				try {
					handleEditListSortDragEnd(
						this.thumbDragState,
						this.thumbSortContainer,
						cardItem.items,
						() => {
							const nextPreviewIndex = cardItem.items.findIndex(image => image.id === previewImageId);
							if (nextPreviewIndex >= 0) {
								this.setPreviewImageIndex(cardItem, nextPreviewIndex);
							}
						},
					);
				} finally {
					this.resetThumbDrag();
				}
			},
			resetThumbDrag() {
				clearEditListSortDragState(this.thumbDragState);
				this.thumbDragItemId = '';
				this.thumbSortContainer = null;
			},
			getPreviewCoverUrl(item) {
				const index = this.getPreviewImageIndex(item);
				const image = item.items?.[index];
				return getImageCardImageUrl(image) || getImageCardImageUrl(getImageCardCoverImage(item));
			},
			getSwatchStyle(color) {
				const normalized = normalizeHexColor(color);
				return {
					background: normalized,
					borderColor: getSwatchBorderColor(normalized),
				};
			},
			syncForm() {
				this.form = normalizeImageCardData(this.data);
				this.heightDraft = this.form.imageHeight;
				this.radiusDraft = this.form.borderRadius;
				if (
					this.selectedIndex != null
					&& this.selectedIndex >= this.form.items.length
				) {
					this.selectedIndex = null;
				}
			},
			selectItem(index) {
				this.selectedIndex = index;
				this.ensureActivePanelVisible();
			},
			clearSelection() {
				this.selectedIndex = null;
				this.activePanel = '';
			},
			togglePanel(panel) {
				this.activePanel = this.activePanel === panel ? '' : panel;
				if (panel === 'height') {
					this.heightDraft = this.form.imageHeight;
				}
				if (panel === 'radius') {
					this.radiusDraft = this.form.borderRadius;
				}
				if (this.activePanel) {
					this.ensureActivePanelVisible();
				}
			},
			addCard() {
				this.form.items.push(createDefaultImageCardItem({}, this.form.items.length));
				this.selectedIndex = this.form.items.length - 1;
			},
			revokeItemImages(item) {
				(item?.items ?? item?.images ?? []).forEach(image => {
					if (image?.local) {
						revokeLocalImageUrl(image.previewUrl);
					}
				});
			},
			deleteItem(index) {
				if (this.form.items.length <= 1) return;
				const removed = this.form.items[index];
				this.revokeItemImages(removed);
				this.form.items.splice(index, 1);
				if (this.selectedIndex === index) {
					this.selectedIndex = null;
					this.activePanel = '';
				} else if (this.selectedIndex != null && this.selectedIndex > index) {
					this.selectedIndex -= 1;
				}
			},
			deleteSelectedImage() {
				const item = this.selectedItem;
				if (!item?.items?.length || item.items.length <= 1) return;
				const previewIndex = this.getPreviewImageIndex(item);
				const [removed] = item.items.splice(previewIndex, 1);
				if (removed?.local) {
					revokeLocalImageUrl(removed.previewUrl);
				}
				const nextIndex = Math.min(previewIndex, item.items.length - 1);
				this.setPreviewImageIndex(item, Math.max(0, nextIndex));
			},
			triggerReplaceCover() {
				this.imageSelectMode = 'replace';
				this.$refs.imageInput?.click();
			},
			triggerAddImage() {
				this.imageSelectMode = 'add';
				this.$refs.imageInput?.click();
			},
			async onImageSelect(event) {
				const file = event.target.files?.[0];
				event.target.value = '';
				if (!file || !isLocalImageFile(file) || !this.selectedItem) return;
				if (file.size > MAX_LOCAL_IMAGE_SIZE) return;

				this.isUploading = true;
				this.uploadTasks = createUploadTasks([file]);
				try {
					const [item] = await uploadHeaderMediaFiles(this, {
						type: 'image',
						files: [file],
						onProgress: payload => updateUploadTaskProgress(this.uploadTasks, payload),
					});

					if (this.imageSelectMode === 'add') {
						this.selectedItem.items.push(item);
						this.setPreviewImageIndex(this.selectedItem, this.selectedItem.items.length - 1);
						return;
					}

					const previewIndex = this.getPreviewImageIndex(this.selectedItem);
					const current = this.selectedItem.items[previewIndex];
					const nextImage = replaceImageCardGalleryImage(
						current,
						file,
						() => item,
					);
					if (this.selectedItem.items.length) {
						this.selectedItem.items[previewIndex] = nextImage;
					} else {
						this.selectedItem.items.push(nextImage);
					}
				} catch (error) {
					this.$message?.error?.('上传失败');
				} finally {
					this.isUploading = false;
					this.uploadTasks = [];
				}
			},
			toggleImageCount() {
				if (!this.selectedItem) return;
				this.selectedItem.showImageCount = !this.selectedItem.showImageCount;
			},
			onSubtitleColorInput(color) {
				if (!this.selectedItem) return;
				this.selectedItem.subtitleColor = normalizeHexColor(color);
			},
			onTitleColorInput(color) {
				if (!this.selectedItem) return;
				this.selectedItem.titleColor = normalizeHexColor(color);
			},
			applyHeight() {
				this.form.imageHeight = Math.max(1, Number(this.heightDraft) || IMAGE_CARD_DEFAULT_HEIGHT);
				this.activePanel = '';
			},
			applyRadius() {
				this.form.borderRadius = Math.max(0, Number(this.radiusDraft) || 0);
				this.activePanel = '';
			},
			onCancel() {
				this.$emit('update:visible', false);
			},
			onConfirm() {
				const payload = normalizeImageCardData({
					...this.form,
					items: this.form.items.map(item => ({
						...item,
						subtitle: item.subtitle?.trim() || ' ',
						title: item.title?.trim() || ' ',
					})),
				});
				this.$emit('confirm', payload);
				this.$emit('update:visible', false);
			},
		},
	};
</script>

<style scoped lang="less">
	@import '../styles/edit-float-panel.less';

	.edit-float-panel(g-image-card-edit__panel);
	.edit-float-toolbar(g-image-card-edit__toolbar);
	.edit-float-action(g-image-card-edit__action);

	.g-image-card-edit {
		min-height: 360px;
		padding: 4px 0 12px;
	}

	.g-image-card-edit__actions {
		.edit-list-sort-actions-row();
		margin-bottom: 16px;
	}

	.g-image-card-edit__actions-btns {
		.edit-list-sort-actions-btns();
	}

	.g-image-card-edit__batch-btn {
		border: none;
		background: transparent;
		padding: 0;
		font-size: 13px;
		color: #285af9;
		cursor: pointer;

		&:hover {
			color: #1d4ed8;
		}
	}

	.g-image-card-edit__grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 12px;
		width: 100%;
		max-width: 520px;
		margin: 0 auto;
		overflow: visible; 
	}

	.g-image-card-edit__cell-wrap {
		position: relative;
		z-index: 0;
		overflow: visible;

		&.is-active {
			z-index: 2;
		}

		&:hover .g-image-card-edit__card-delete,
		&.is-active .g-image-card-edit__card-delete {
			opacity: 1;
			pointer-events: auto;
		}
	}

	.g-image-card-edit__card-delete {
		position: absolute;
		top: -8px;
		right: -8px;
		z-index: 3;
		width: 22px;
		height: 22px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		border: none;
		border-radius: 50%;
		background: rgba(0, 0, 0, 0.55);
		color: #fff;
		cursor: pointer;
		opacity: 0;
		pointer-events: none;
		transition: opacity 0.15s ease, background 0.15s ease;

		i {
			font-size: 12px;
			line-height: 1;
		}

		&:hover:not(:disabled) {
			background: #ff4d4f;
		}
	}

	.g-image-card-edit__hint {
		.edit-list-sort-hint-text();
	}

	.g-image-card-edit__cell {
		box-sizing: border-box;
		border: 2px dashed #fff;
		border-radius: 2px;
		cursor: pointer;

		&.is-selected {
			border-color: #285af9;
		}
	}

	.g-image-card-edit__cover {
		position: relative;
		width: 100%;
		height: auto;
		overflow: hidden;
		background: #f0f0f0;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			display: block;
		}

		i {
			font-size: 28px;
			color: #bfbfbf;
		}
	}

	.g-image-card-edit__badge {
		position: absolute;
		right: 8px;
		bottom: 8px;
		padding: 2px 8px;
		border-radius: 10px;
		background: rgba(0, 0, 0, 0.45);
		color: #fff;
		font-size: 11px;
		line-height: 1.4;
	}

	.g-image-card-edit__subtitle-input {
		display: block;
		width: 100%;
		margin-top: 8px;
		border: none;
		outline: none;
		background: transparent;
		font-size: 12px;
		font-family: inherit;
		padding: 0;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.g-image-card-edit__title-input {
		display: block;
		width: 100%;
		margin-top: 4px;
		border: none;
		outline: none;
		background: transparent;
		font-size: 15px;
		font-weight: 600;
		font-family: inherit;
		padding: 0;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.g-image-card-edit__thumbs {
		display: flex;
		align-items: center;
		gap: 6px;
		margin-top: 8px;
		overflow-x: auto;

		&::-webkit-scrollbar {
			display: none;
		}
	}

	.g-image-card-edit__thumb {
		flex-shrink: 0;
		width: 36px;
		height: 36px;
		overflow: hidden;
		background: #f0f0f0;
		box-sizing: border-box;
		border: 2px solid transparent;
		cursor: grab;
		user-select: none;

		&:active {
			cursor: grabbing;
		}

		&.is-active {
			border-color: #285af9;
		}

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			display: block;
			pointer-events: none;
		}

		&--add {
			display: flex;
			align-items: center;
			justify-content: center;
			border: 1px dashed #d9d9d9;
			background: #fafafa;
			color: #999;
			font-size: 18px;
			line-height: 1;
			cursor: pointer;

			&:hover {
				border-color: #285af9;
				color: #285af9;
			}
		}
	}

	.g-image-card-edit__colors {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		margin-left: auto;
		padding-left: 8px;
	}

	.g-image-card-edit__swatch {
		position: relative;
		display: inline-block;
		width: 18px;
		height: 18px;
		border: 1px solid #b0b0b0;
		border-radius: 3px;
		cursor: pointer;
		overflow: hidden;
		flex-shrink: 0;
		box-sizing: border-box;

		&:hover {
			box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.25);
		}
	}

	.g-image-card-edit__color-input {
		position: absolute;
		inset: 0;
		width: 100%;
		height: 100%;
		padding: 0;
		border: none;
		opacity: 0;
		cursor: pointer;
	}

	.g-image-card-edit__sub-row {
		display: flex;
		align-items: center;
		flex-wrap: nowrap;
		gap: 8px;
		padding: 8px 12px 10px;
		border-top: 1px solid #f0f0f0;
		white-space: nowrap;
	}

	.g-image-card-edit__sub-label {
		font-size: 13px;
		color: #666;
		white-space: nowrap;
		flex-shrink: 0;
	}

	.g-image-card-edit__sub-input {
		width: 88px;
		flex-shrink: 0;
	}

	.g-image-card-edit__sub-confirm {
		flex-shrink: 0;
		height: 28px;
		padding: 0 12px;
		border: none;
		border-radius: 4px;
		background: #285af9;
		color: #fff;
		font-size: 12px;
		line-height: 28px;
		white-space: nowrap;
		cursor: pointer;

		&:hover {
			background: #3868ff;
		}
	}

	.g-image-card-edit__sub-default {
		font-size: 12px;
		color: #999;
		white-space: nowrap;
		flex-shrink: 0;
	}

	.g-image-card-edit__file-input {
		display: none;
	}
</style>

<style lang="less">
	@import '../styles/edit-float-panel.less';

	.g-image-card-edit-modal {
		.edit-modal-body();
		.edit-modal-scroll();

		.g-image-card-edit-modal__ok {
			white-space: nowrap;
			flex-shrink: 0;

			&:hover,
			&:focus {
				background: #3868ff;
				border-color: #3868ff;
			}
		}
	}
</style>
